import { useEffect } from "react";
import useSingleJobSkus from "../zustandStores/singleJobSkus";
import { zustandFetchStates } from "../services/constants";

interface CreditsBreakUp {
  mrc: number;
  discountedCredits: number;
  isSpecialPrice: boolean;
  fetchState?: string;
}
type JobPlan = "BASIC" | "PREMIUM" | "CANDIDATE_DOWNLOAD";
interface CreditsBreakUpProps {
  jobId?: number;
  categoryId?: number;
  cityId?: string;
  jobPlan?: JobPlan;
  requestFlow?: string;
}

const usePremiumJobCreditsBreakUp = (
  props?: CreditsBreakUpProps
): CreditsBreakUp => {
  const {
    jobId,
    categoryId,
    cityId,
    jobPlan = "PREMIUM",
    requestFlow = ""
  } = props || {};
  const { fetchData, fetchState, premiumSku, basicSku, downloadSku } =
    useSingleJobSkus((state: any) => ({
      fetchData: state.fetchData,
      fetchState: state.fetchState,
      premiumSku: state.premiumSku,
      basicSku: state.basicSku,
      downloadSku: state.downloadSku
    }));

  useEffect(() => {
    // Skip API call if requestFlow is OFFLINE_PURCHASE
    if (requestFlow === "OFFLINE_PURCHASE") {
      return;
    }

    const params = {
      ...(jobId ? { jobId } : {}),
      ...(categoryId ? { categoryId } : {}),
      ...(cityId ? { cityId } : {})
    };
    fetchData(params);
  }, [jobId, categoryId, cityId, requestFlow]);

  if (fetchState === zustandFetchStates.SUCCESS) {
    switch (jobPlan) {
      case "PREMIUM": {
        const { credits: mrc, discountedCredits, isSpecial } = premiumSku;
        return { mrc, discountedCredits, isSpecialPrice: isSpecial };
      }
      case "BASIC": {
        const { credits: mrc, discountedCredits, isSpecial } = basicSku;
        return { mrc, discountedCredits, isSpecialPrice: isSpecial };
      }
      case "CANDIDATE_DOWNLOAD": {
        const { credits: mrc, discountedCredits, isSpecial } = downloadSku;
        return { mrc, discountedCredits, isSpecialPrice: isSpecial };
      }
    }
  }

  return { mrc: 0, discountedCredits: 0, isSpecialPrice: false, fetchState };
};

export default usePremiumJobCreditsBreakUp;
